import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex justify-between flex-1" }
const _hoisted_2 = { class: "flex justify-between flex-1" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src", "onClick"]
const _hoisted_5 = { class: "flex justify-between flex-1" }
const _hoisted_6 = { class: "flex flex-col gap-2" }
const _hoisted_7 = { class: "d-flex justify-between" }
const _hoisted_8 = { class: "font-bold min-w-[200px] text-left" }

import { usePortKlaipeda } from '@/store/portKlaipeda';
  import { ref } from 'vue';
  import ButtonCustom from '@/components/components/buttonCustom.vue';
  import { formatLabel } from '../helpers/helper';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'USAPortView',
  setup(__props) {

  const vin = ref<string>('');
  const { getData } = usePortKlaipeda();
  const dataCar = ref(null);
  const visibleDetailsBlock = ref<boolean>(false);
  const photosUsa = ref([]);
  const search = async () => {
    if (!vin.value) return;
    dataCar.value = await getData(vin.value);
    photosUsa.value =
      dataCar.value?.data_car?.upload
        ?.split('; ')
        .map((pair) => pair.trim())
        .filter((pair) => pair !== '0' && pair !== '0;')
        .map((pair) => {
          const cleanedPair = pair.replace(';', '');
          return cleanedPair.includes('cdn.liontrans')
            ? cleanedPair
            : `https://cdn.liontrans.com/${cleanedPair}`;
        }) ??
      dataCar.value?.data_car?.upload_new
        ?.split('; ')
        .map((pair) => pair.trim())
        .filter((pair) => pair !== '0' && pair !== '0;')
        .map((pair) => {
          const cleanedPair = pair.replace(';', '');
          return cleanedPair.includes('lnt1.nbg1.your-objectstorage')
            ? cleanedPair
            : `https://lnt1.nbg1.your-objectstorage.com/${cleanedPair}`;
        }) ??
      [];

    console.log(photosUsa, dataCar.value);
  };

return (_ctx: any,_cache: any) => {
  const _component_Card = _resolveComponent("Card")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_IftaLabel = _resolveComponent("IftaLabel")!
  const _component_Image = _resolveComponent("Image")!
  const _component_Carousel = _resolveComponent("Carousel")!
  const _component_Drawer = _resolveComponent("Drawer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Card, null, {
      content: _withCtx(() => _cache[3] || (_cache[3] = [
        _createElementVNode("div", { class: "flex justify-between flex-1 text-xl" }, " Check photos in the USA port: ", -1)
      ])),
      _: 1
    }),
    _createVNode(_component_Card, { class: "mt-2" }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_IftaLabel, { class: "w-full" }, {
            default: _withCtx(() => [
              _createVNode(_component_InputText, {
                id: "vin-code",
                modelValue: vin.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vin).value = $event))
              }, null, 8, ["modelValue"]),
              _cache[4] || (_cache[4] = _createElementVNode("label", { for: "vin-code" }, "Vin Code:", -1))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Card, { class: "mt-2" }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(ButtonCustom, {
            onClick: search,
            title: "Search"
          })
        ])
      ]),
      _: 1
    }),
    (photosUsa.value.length > 0)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 0,
          class: "mt-2"
        }, {
          title: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("Photos from USA port:")
          ])),
          content: _withCtx(() => [
            (photosUsa.value.length > 0)
              ? (_openBlock(), _createBlock(_component_Carousel, {
                  key: 0,
                  value: photosUsa.value,
                  numVisible: 1,
                  numScroll: 1
                }, {
                  item: _withCtx((itemProps) => [
                    _createVNode(_component_Image, {
                      alt: "Image",
                      preview: ""
                    }, {
                      previewicon: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createElementVNode("i", { class: "pi pi-search" }, null, -1)
                      ])),
                      image: _withCtx(() => [
                        _createElementVNode("img", {
                          src: itemProps.data,
                          alt: "image"
                        }, null, 8, _hoisted_3)
                      ]),
                      preview: _withCtx((previewProps) => [
                        _createElementVNode("img", {
                          src: itemProps.data,
                          alt: "preview",
                          style: _normalizeStyle(previewProps.style),
                          onClick: previewProps.onClick
                        }, null, 12, _hoisted_4)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }, 8, ["value"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (dataCar.value)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 1,
          class: "stats-card mt-2"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(ButtonCustom, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (visibleDetailsBlock.value = true)),
                title: "Show Car Detail Info"
              })
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Drawer, {
      visible: visibleDetailsBlock.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visibleDetailsBlock).value = $event)),
      header: "Details",
      position: "right",
      class: "!bg-gray-50"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
            'booking_number',
            'container_number',
            'container_line',
            'date_of_loading',
            'deliver_date',
            'expect_delivery',
            'geoport',
            'lot',
            'year',
            'manufacturer',
            'model',
            'sale_date',
            'vin',
            'key_status',
          ], (key) => {
            return _createElementVNode("div", { key: key }, [
              _cache[7] || (_cache[7] = _createElementVNode("hr", { class: "mb-2" }, null, -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(formatLabel)(key)), 1),
                _createElementVNode("div", null, _toDisplayString(dataCar.value?.data_car?.[key]), 1)
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("hr", { class: "mt-2" }, null, -1))
            ])
          }), 64))
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})